BuyButton = window.BuyButton ?= {}

MagicEventBus = require 'magic-event-bus/lib/frizzle.js'
BuyButton.View = require '../frontend/views/buy_button'
MultiOptionModal = require './multi_option_modal'

BuyButton.resetMultiOptionLink = (payload) ->
  # wait until pageshow to reset radio buttons
  $(window).on 'pageshow', ->
    if $('.multi-option-breakout').length
      $wrapper = '.multi-option-breakout'
      buyLink = $('#buy-link').attr('href')

    return unless buyLink

    linkWithNoQuantity = BuyButton.removeQuantityParam(buyLink)
    $newSelectedInput = $($wrapper + ' input[value="' + linkWithNoQuantity + '"]')
    $newSelectedInput.prop('checked', true)

BuyButton.removeQuantityParam = (url) ->
  url.split(/&quantity=[0-9]+[^&]?/).join('')

BuyButton.init = (payload, done) ->
  {buyButton, variations, goodsWarranty, cart} = payload

  @eventBus = new MagicEventBus()

  if buyButton.multiOptionEnabled
    BuyButton.resetMultiOptionLink payload

  @view = new BuyButton.View
    multiOptionEnabled: buyButton.multiOptionEnabled
    multiOptionInline: buyButton.multiOptionInline
    buyButtonEnabled: buyButton.buyButtonEnabled
    goodsCartFormEnabled: !!cart
    hasVariations: variations?
    goodsWarranty: goodsWarranty

  MultiOptionModal.init(payload)
  done()

module.exports = BuyButton
